import React from 'react';

import { cssMap } from '@atlaskit/css';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Box } from '@atlaskit/primitives/compiled/box';
import { AgentProfileCardSkeleton } from '@atlassian/conversation-assistant-agent/common/ui/AgentProfileCardSkeleton';
import { AgentCardSkeleton } from '@atlassian/studio-browse-kit/agent-card-skeleton';

const styles = cssMap({
	card: {
		width: '220px',
	},
});

/** Shows the loading skeleton matching the active agent profile card. */
export function AgentCardLoading(): React.JSX.Element {
	return fg('rovo_agent_profile_card_browse_kit') && fg('rovo_agents_studio_browse_kit_uplift') ? (
		<Box xcss={styles.card}>
			<AgentCardSkeleton />
		</Box>
	) : (
		<AgentProfileCardSkeleton />
	);
}
